export default __webpack_public_path__ + "static/media/check_mark.dcd38140.svg";